import { Container } from "../../Input/styles";

interface TextAreaProps {
  id: string;
  name: string;
  placeholder?: string;
  label?: string;
  defaultValue?: any;
  value?: string;
  required: boolean;
  containerClassName?: string;
  inputClassname?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onPaste?: (e: React.ClipboardEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
  maxLength?: number;
  error?: any;
  apiErrorName?: string;
  handleApiErrorRemove?: (errorName: string) => void;
}

function TextArea({
  id,
  name,
  placeholder,
  label,
  required,
  onChange,
  defaultValue,
  onPaste,
  value,
  inputClassname = "",
  containerClassName = "",
  maxLength,
  error,
  disabled,
  onBlur,
  apiErrorName,
  handleApiErrorRemove,
}: TextAreaProps) {
  return (
    <Container className={containerClassName}>
      {label && <label htmlFor={id}>{label}</label>}

      <textarea
        id={id}
        name={name}
        placeholder={placeholder}
        required={required}
        value={value}
        onPaste={onPaste}
        className={inputClassname}
        defaultValue={defaultValue}
        onChange={onChange}
        disabled={disabled}
        maxLength={maxLength}
        onBlur={onBlur}
        onFocus={() =>
          apiErrorName &&
          handleApiErrorRemove &&
          handleApiErrorRemove(apiErrorName)
        }
      />
      {error && <small>Campo inválido</small>}
    </Container>
  );
}

export default TextArea;
